/**
 *
 * @module app/components/IconCarousel
 */
import XsellMicroNotification from './crossSell/signposting/XsellMicroNotification';
/**
 * @returns {string}
 */
const getMicroActiveState = () => {

    const microConfig = document.querySelector('#xsell-micro-notification-config');
    if (microConfig) {
        return microConfig.getAttribute('data-active');
    } else {
        return 'false';
    }
};

/**
 * @param gamesLobbyIcon
 */
const appendMicroSignSpanToIcon = (gamesLobbyIcon) => {

    const microEl = document.createElement('span');
    microEl.setAttribute('class', 'xsell-micro-notification');

    return gamesLobbyIcon.appendChild(microEl);
};

/**
 * @param gamesLobbyIcon
 */
const wrapIconWithMicroNotification = (gamesLobbyIcon) => {

    const microEl = appendMicroSignSpanToIcon(gamesLobbyIcon);

    var microNotification = new XsellMicroNotification({
        container: microEl,
        shouldExpire: true,
    });
    microNotification.init();
};

/**
 * Initialise micro notification for the games lobby icon
 * @returns {void}
 * @private
 */
const initXsellMicroNotification = () => {

    if(getMicroActiveState() === 'true') {

        let gamesLobbyIcon = document.querySelector('#carousel #nav-more-games');

        if(gamesLobbyIcon) {
            wrapIconWithMicroNotification(gamesLobbyIcon);
        }
    }
};

/**
 * Event handler for DOM Ready
 *
 * @returns {void}
 *
 * @private
 */
const onDOMReady = () => {
    initXsellMicroNotification();
};

/**
 * This will make this module start listening events declared for the DOM set-up
 *
 * @returns {void}
 *
 * @private
 */
const subscribeToMessageBus = () => {
    window.WH.messageBus.subscribe('AppJs.domReady', onDOMReady);
};

/**
 * This function initializes the communication with the native app
 *
 * @returns {void}
 *
 * @public
 */
export default {
    init: () => subscribeToMessageBus(),
};
